import {Pie} from 'vue-chartjs/legacy'
import {ArcElement, Chart as ChartJS, Legend, Title, Tooltip} from 'chart.js'

import {mapState} from 'vuex'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  components: { Pie },

  computed: {
    ...mapState('statistics', ['graphsData', 'isLoadingGraphs']),

    chartData() {
      if (!this.graphsData.length) {
        return { labels: [], datasets: [] }
      }

      const items = this.graphsData
        .filter(i => i.saleAmount > 0)
        .sort((a, b) => a.saleAmount - b.saleAmount)

      const total = items.reduce((acc, cur) => acc + cur.count, 0)

      const filtered = []
      let othersSum = 0

      items.forEach(i => {
        const percent = (i.count / total) * 100

        if (percent >= 5) {
          filtered.push(i)
        } else {
          othersSum += i.count
        }
      })

      if (othersSum > 0) {
        filtered.push({
          saleAmount: 'Others',
          count: othersSum
        })
      }

      const labels = filtered.map(i =>
        typeof i.saleAmount === 'number'
          ? i.saleAmount.toFixed(2)
          : i.saleAmount
      )

      const data = filtered.map(i => i.count)

      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: [
              '#4A90E2',
              '#50E3C2',
              '#F5A623',
              '#D0021B',
              '#8E44AD',
              '#2ECC71',
              '#F39C12',
              '#95A5A6'
            ]
          }
        ]
      }
    },

    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            align: 'start',
            labels: {
              usePointStyle: true
            }
          },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const value = ctx.raw
                const total = ctx.dataset.data.reduce((s, v) => s + v, 0)
                const percent = ((value / total) * 100).toFixed(1)
                return `${ctx.label}: ${value} (${percent}%)`
              }
            }
          }
        }
      }
    }
  }
}
